module.exports = __webpack_public_path__ + "media/images/icons/recycle-aead1d04445ae1773e84b86091b1a32f.svg";